
import React, { useEffect } from 'react';
import PageLayout from '../components/layout/PageLayout';
import StagingHero from '../components/staging/StagingHero';
import CoreValueSection from '../components/staging/CoreValueSection';
import ProcessSection from '../components/staging/ProcessSection';
import ShowcaseSection from '../components/staging/ShowcaseSection';
import WhoWeWorkWith from '../components/staging/WhoWeWorkWith';
import LocationSection from '../components/staging/LocationSection';
import FinalCTA from '../components/staging/FinalCTA';
import { createLocalBusinessSchema, createServiceSchema, astremBusinessData } from '../utils/seoUtils';
import { updateMetaTags } from '../utils/ottoSeoUtils';

const HOME_META_DESCRIPTION = "Beautiful, blazing-fast websites built in Framer. SEO-optimized, fully managed, and crafted to showcase your brand at its best. Based in Baton Rouge, serving clients nationwide.";

const HomepageStaging = () => {
  useEffect(() => {
    updateMetaTags({
      title: "Premium Web Design | Beautiful, Fast Websites | Astrem",
      description: HOME_META_DESCRIPTION,
      type: 'website',
      imageUrl: "https://portal.astrem.co/users/u9/9466/astremagency/lovableagentsite/astrem_og_Websites%20Content%20Marketing%20Solutions.jpg",
      canonicalUrl: "https://astrem.co/staging"
    });
  }, []);

  const localBusinessSchema = createLocalBusinessSchema(astremBusinessData);
  
  const mainServices = [
    {
      name: "Premium Web Design",
      description: "Beautiful, blazing-fast websites built in Framer. SEO-optimized and fully managed.",
      provider: {
        name: "Astrem",
        url: "https://astrem.co"
      },
      url: "https://astrem.co/web-design"
    }
  ];

  return (
    <PageLayout
      title="Premium Web Design | Beautiful, Fast Websites | Astrem"
      description={HOME_META_DESCRIPTION}
      ogImage="https://portal.astrem.co/users/u9/9466/astremagency/lovableagentsite/astrem_og_Websites%20Content%20Marketing%20Solutions.jpg"
      canonicalPath="/staging"
      schemaData={[localBusinessSchema, ...mainServices.map(service => createServiceSchema(service))]}
    >
      <main className="flex-grow">
        <StagingHero />
        <CoreValueSection />
        <ProcessSection />
        <ShowcaseSection />
        <WhoWeWorkWith />
        <LocationSection />
        <FinalCTA />
      </main>
    </PageLayout>
  );
};

export default HomepageStaging;
